import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "yesNo" })
export class yesNoPipe implements PipeTransform {
    transform(value: boolean, field: string): string {
    
        return value ? 'Yes' : 'No';
    }
}
